<template>
   <div class="row">
      <div class="col-md-12">
         <div class="form-group">
            <div class="nested-panel-heading skill-heading"><h3 class="nested-title">Type of Chat</h3></div>
            <div class="">
               <div>
                  <div class="form-check form-check-inline">
                        <input class="form-check-input" checked type="radio" name="chattype" value="" id="liveonly"  v-on:click="livechatsetting=true;chatBotSetting=false;">
                        <label class="form-check-label">
                           Live Only
                        </label> 
                  </div>
                  <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="chattype" value="" id="chatbotonly"  v-on:click="chatBotSetting=true;livechatsetting=false;">
                        <label class="form-check-label" for="chatbotonly" >
                        Chatbot
                        </label>
                  </div>
                  <!-- <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" name="chattype" value="" id="chatbotlive" v-on:click="chatBotSetting=true;livechatsetting=true;">
                        <label class="form-check-label" for="chatbotlive">
                           Chatbot+Live Chat
                        </label>
                  </div> -->
            </div>
            </div>
         </div>
      </div>
      <div class="col-md-12">
         <div class="nav-tabs-custom">
                        <ul class="nav nav-tabs">
                           <li class="nav-item"><a class="nav-link active" data-bs-toggle="tab" data-bs-target="#tab_property_41" role="tab" aria-controls="formbody"  aria-selected="true"><i class="fa fa-gear"></i>  <span>Chat Settings</span></a> </li>
                           <li class="nav-item"><a class="nav-link" data-bs-toggle="tab" data-bs-target="#tab_property_42" role="tab" aria-controls="formbody"  aria-selected="true"><i class="fa  fa-desktop"></i> <span>Theme </span></a> </li>
                           <li class="nav-item" v-if="chatBotSetting != true"><a class="nav-link" data-bs-toggle="tab" data-bs-target="#tab_property_44" role="tab" aria-controls="formbody"  aria-selected="true"><i class="fa fa-newspaper-o"></i> <span>Pre-Chat Survey  </span></a> </li> 
                           <!-- <li class="nav-item" v-if="chatBotSetting != true"><a class="nav-link" data-bs-toggle="tab" data-bs-target="#tab_property_43" role="tab" aria-controls="formbody"  aria-selected="true"><i class="fa fa-css3"></i> <span>Override Code  </span></a> </li>  -->
                        </ul>
                        <div class="tab-content">
                           <div class="tab-pane active" id="tab_property_41">
                              <div class="row form-verticle">
                                <div v-if="livechatsetting == true">
                                 <div class="row">
                                    <div class="col-md-3">
                                       <div class="form-group">
                                          <label class="control-label text-left"> Chat Name</label>
                                          <input class="form-control" type="text">
                                       </div> 
                                    </div>
                                    <div class="col-md-3">
                                       <div class="form-group">
                                          <label class="control-label text-left"> Chat ID</label>
                                          <input class="form-control" type="text">
                                       </div> 
                                    </div>
                                    
                                    <div class="col-md-6">
                                       <div class="form-group">
                                          <label class="control-label text-left"> Description</label>
                                          <input class="form-control" type="text">
                                       </div> 
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="col-md-6">
                                       <div class="form-group">
                                          <div class="nested-panel-heading skill-heading"><h3 class="nested-title">Topic Selection Types</h3></div>
                                          <div class="">
                                             <div>
                                                
                                                <div class="form-check form-check-inline">
                                                      <input class="form-check-input" checked type="radio" value="" id="wordpress" name="topic" v-on:click="singletopic=true;multipletopic=false;wholetopiclist=false;">
                                                      <label class="form-check-label">
                                                      Single Topic <span v-tooltip="{text: ' Use this option when all supporting chat agents have access to topic. The customer will not be presented a topic selection menu.',theme: {placement: 'bottom', }}"><i class="fa fa-question-circle text-info help-icon" ></i></span>
                                                      </label> 
                                                </div>
                                                
                                                <div class="form-check form-check-inline">
                                                      <input class="form-check-input" type="radio" value="" id="htmlwebsite" name="topic" v-on:click="singletopic=false;multipletopic=true;wholetopiclist=false;">
                                                      <label class="form-check-label" for="htmlwebsite" >
                                                      Multiple Topics <span v-tooltip="{text: 'Use this option to present the customer a menu to choose a topic. You will specify a friendly name to display in the topic selection menu.',theme: {placement: 'bottom', }}"><i class="fa fa-question-circle text-info help-icon" ></i></span>
                                                      </label>
                                                </div>
                                                
                                                <div class="form-check form-check-inline">
                                                      <input class="form-check-input" type="radio" value="" id="independentform" name="topic" v-on:click="singletopic=false;multipletopic=false;wholetopiclist=true;">
                                                      <label class="form-check-label" for="independentform">
                                                      All Topics <span v-tooltip="{text: 'The All Topics option will display the standard topic menu for all public topics.',theme: {placement: 'bottom', }}"><i class="fa fa-question-circle text-info help-icon" ></i></span>
                                                      </label>
                                                </div>
                                             
                                          </div>
                                          </div>
                                       </div>
                                    </div>
                                    
                                    <div class="singletopic" v-if="singletopic" >
                                       <div class="col-md-6">
                                          <div class="bg-box mb-2">
                                             <div class="form-group">
                                                <label class="control-label text-left"> Topics </label>
                                                <div class="">
                                                   <Multiselect
                                                   v-model="value"
                                                   placeholder="-Select Topic-"
                                                   label="name"
                                                   :groups="false"
                                                   :searchable="true"
                                                   :options="[ { value: 'All Topic', name: 'All Topic',level:'1'},
                                                            { value: 'Specific Topics', name: 'Specific Topics',level:'1'},
                                                   ]"
                                                   >
                                                   <template v-slot:option="{ option }">
                                                   <span v-bind:class="'op-level-' + option.level"> {{ option.name }} </span>
                                                   </template>
                                                </Multiselect>
                                             
                                                </div>
                                             </div>

                                          </div>
                                       </div>
                                    </div>
                                    <div class="" v-if="multipletopic">
                                       <div class="col-md-12">
                                          <div class="bg-box mb-2">
                                             <div class="search-panel">
                                                <div class="panel panel-default col-12 bg-gray-light p-2">
                                                   <div class="row">
                                                   <div class="col-md-5">
                                                      <label>iService Topic</label>
                                                      </div>
                                                      <div class="col-md-5">
                                                      <label>Menu Display Name</label>
                                                      </div>
                                                   </div>
                                                   <div class="row">
                                                      <div class="col-12 col-md-5">
                                                         <Multiselect
                                                            v-model="value"
                                                            placeholder="-Select or search for topic-"
                                                            label="name"
                                                            :groups="false"
                                                            :searchable="true"
                                                            :options="[ { value: 'All Topic', name: 'All Topic',level:'1'},
                                                                     { value: 'Specific Topics', name: 'Specific Topics',level:'1'},
                                                            ]"
                                                            >
                                                            <template v-slot:option="{ option }">
                                                            <span v-bind:class="'op-level-' + option.level"> {{ option.name }} </span>
                                                            </template>
                                                         </Multiselect>
                                                      </div>
                                                      <div class="col-12 col-md-5">
                                                         <input class="form-control" type="text" value="Sales Department">
                                                      </div>
                                                      <div class="col-12 col-md-2 search-field">
                                                         <button class="btn btn-lg btn-link" type="button" title="Remove Field"><i class="fa fa-times-circle text-red"></i></button>
                                                      </div>
                                                   </div>
                                                   <div class="row float-end"><button class="btn btn-lg btn-link" type="button"><i class="fa fa-plus-circle text-light-blue"></i> Add another topic </button></div>
                                                </div>
                                             
                                          
                                             </div>
                                          </div>
                                       </div>   
                                    </div>
                                    <div class="clearfix"></div>
                                    <div class="col-md-10 mt-3" v-if="!independentSettings && singletopic">
                                       <label class="control-label text-left">Hide Chat When No Agents Available <Toggle /></label>
                                    </div>
                                  </div>
                                </div>
                                <div v-if="chatBotSetting">
                                <div class="row"> 

                                 
                                 <div class="col-md-3">
                                    <div class="form-group has-error">
                                       <label class="control-label text-left"> Chatbot Topic</label>
                                       <select class="form-control">
                                         <option>Select or search a topic</option>
                                       </select>
                                    </div>
                                 </div>
                                 <div class="col-md-3">
                                    <div class="form-group has-error">
                                       <label class="control-label text-left"> Chat Name</label><input class="form-control" type="text"><!---->
                                    </div>
                                 </div>
                                 <div class="col-md-3">
                                    <div class="form-group has-error">
                                       <label class="control-label text-left"> Chat ID</label><input class="form-control" type="text" readonly=""><!---->
                                    </div>
                                 </div>


                                 <div class="col-md-6">
                                    <div class="form-group"><label class="control-label text-left"> Description</label><input class="form-control" type="text"></div>
                                    <br>
                                    <div class="form-group"><input class="form-check-input" type="checkbox" id="allow-agent-chat" name="allowagentchat" value="1"><label class="form-check-label" for="allow-agent-chat"> &nbsp;Allow Chat with Agent</label></div>
                                   
                                    <div class="form-group">
                                       <div class="nested-panel-heading skill-heading"><h3 class="nested-title">Tools</h3></div>
                                       <div>
                                          <label class="switch">
                                            <span class="mright-5"> Files </span><Toggle v-model="tools" />
                                            
                                          </label>
                                       </div>
                                    </div>
                                    <div class="form-group has-error" v-if="tools">
                                       <label class="control-label text-left"> Vector Store ID</label>
                                       
                                       <div class="form-group">
                                          <div class="simple-label multiple position-relative">
                                             <div class="mbottom-15" v-for="(val, index) of optionparameter">
                                                <div class="float-btn-group">

                                                   <button v-if="optionparameter.length != 1" class="margin-5 icon-button button-delete" type="button" @click="removeValue(index)"><i class="fa fa-times-circle"></i></button>
                                                   <input type="text" class="form-control">
                                                </div>
                                             </div>
                                             <button  title="" class="margin-5 icon-button button-add-row" type="button"  @click="addValue"><i class="fa fa-plus-circle"></i> </button>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="form-group">
                                       <div class="nested-panel-heading skill-heading"><h3 class="nested-title">Developer Instructions</h3></div>
                                       <div>
                                          <label class="control-label text-left">This instructions will be added to the prompt submitted into chatbot by the customer.</label>
                                          <textarea class="form-control"></textarea>
                                       </div>
                                    </div>
                                    <div class="nested-panel-heading skill-heading"><h3 class="nested-title">Model Settings</h3></div>
                                    <div class="form-group">
                                       
                                       <label class="control-label text-left mbottom-15"> Select the model for your chatbot <br>
                                          
                                       </label>
                                       <Multiselect
                                                v-model="value"
                                                placeholder="-Select or search for model-"
                                                label="name"
                                                :groups="false"
                                                :searchable="true"
                                                :options="[  { value: 'gpt-4.1', name: 'gpt-4.1',level:'1'},{ value: 'gpt-4.1-mini', name: 'gpt-4.1-mini',level:'1'},
                                                      
                                                ]"
                                                >
                                                <template v-slot:option="{ option }">
                                                <span v-bind:class="'op-level-' + option.level"> {{ option.name }} </span>
                                                </template>
                                             </Multiselect>
                                      
                                    </div>
                                    <div class="form-group">
                                       <label class="control-label text-left mbottom-15"> Temperature <br>
                                          <span class="fw-normal"> This controls the randomness of the responses from the chatbot. Low values are less random and higher values are more creative and potentially less accurate. Higher values are good for creative writing, and lower values are best for accuracy.</span>
                                       </label>
                                       <div class="w-100">
                                          <div class="slider-wrapper">
                                           <Slider2 v-model="value2" :min="0.01"
                                       :max="2" :step="0.01" :format="value => value.toFixed(2)" />
                                             <div class="slider-labels">
                                                <span>0.01</span>
                                                <span>2.00</span>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="form-group">
                                       <label class="control-label text-left mbottom-15"> Top P  <br>
                                          <span class="fw-normal">  This controls the diversity of the responses by limiting the number of results the model can choose from. A value of 0.5 will only use the top 50% of the responses, ensuring the highest probability results are used.</span>
                                       </label>
                                       <div class="w-100">
                                          <div class="slider-wrapper">
                                           <Slider2 v-model="value3" :max="1" :step="0.01" :format="value => value.toFixed(2)"  />
                                             <div class="slider-labels">
                                                <span>0.01</span>
                                                <span>1.00</span>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <div class="form-group">
                                       <label class="control-label text-left mbottom-15"> Max Tokens <br>
                                          <span class="fw-normal">This is the maximum number of tokens to generate, including the prompt and the completions result returned.</span>
                                       </label>
                                       <div class="w-100">
                                          <div class="slider-wrapper">
                                             <Slider2 v-model="value4" :max="32768" :step="1"   />
                                             <div class="slider-labels">
                                                   <span>1</span>
                                                   <span>32768</span>
                                             </div>
                                          </div>
                                        </div>
                                    </div>
                                 </div>
                                 <div class="col-md-6">
                                    <label class="control-label text-left"> Opening Text</label>
                                    <textarea class="form-control"></textarea>
                                 </div>
                                </div>
                                </div>

                               <div class="clearfix"></div>
                               <div class="row">
                                 <div class="col-md-10">
                                    <div class="nested-panel-heading skill-heading"><h3 class="nested-title">Target  Deployment</h3></div> 
                                    <div class="bg-box mb-3">
                                       <label class="control-label text-left mb-3 hb-bottom">Standalone Chat</label>
                                       <p>Your customer can load the URL in any browser to start the chat.</p>    
                                       <a target="_blank" href="https://tenant.iservicecrm.com/s/ChatName/chat?topic=10">https://tenant.iservicecrm.com/s/ChatName/chat?topic=10</a>
                                    </div>
                                    <div class="bg-box mb-3">
                                       <label class="control-label text-left mb-3 hb-bottom">WordPress</label>
                                       

                                       <p>To install iService Chat on a WordPress website, configure the setup in this configuration and then install the WordPress plugin using the .zip file. </p>
                                       <button class="btn btn-success mb-2">
                                          Download plugin
                                          <i class="fa fa-download"></i>
                                       </button> <a href="https://1to1service.iservicecrm.com/s/sales/chat">https://1to1service.iservicecrm.com/s/sales/chat</a>
                                    </div>

                                    <div class="bg-box mb-3">
                                       <label class="control-label text-left mb-3 hb-bottom">HTML Website</label>
                                    
                                       <p>To install iService Chat on an HTML website, copy the script code into the footer or other element of your website that appears on the pagges that required chat.</p>
                                       <code-highlight language="html" :copy="true">
                                          <pre><code v-pre>&lt;script&gt;...  &lt;/script&gt;</code>
                                          
                                          </pre>

                                       </code-highlight>
                                    </div>

                                 
                                 </div>
                                 <div class="clearfix"></div>

                                 <div class="col-md-8 mb-3">
                                    
                                       <div class="nested-panel-heading skill-heading"><h3 class="nested-title">reCAPTCHA</h3></div>
                                       <p>You can prevent bots from submitting your customer chat form by turning on reCAPTCHA.</p>
                                       <div class="form-check form-check-inline">
                                          <input class="form-check-input" type="checkbox" id="captcha" name="enablecaptcha" value="" checked v-model="enableCaptcha">
                                          <label class="form-check-label" for="captcha"> Turn on reCAPTCHA for this chat form. </label>
                                       </div>
                                       <div class="clearfix"></div>
                                       <div class="mt-2 ps-4" v-if="enableCaptcha == true">
                                          <div class="form-check form-check-inline">
                                             <input class="form-check-input" type="radio" id="invisiblecaptcha" name="captcha" value="" checked>
                                             <label class="form-check-label" for="captcha"> Use invisible reCAPTCHA </label>
                                          </div>
                                          <div class="clearfix"></div>
                                          <div class="form-check form-check-inline">
                                             <input class="form-check-input" type="radio" id="checkboxcaptcha" name="captcha" value="">
                                             <label class="form-check-label" for="captcha"> Use Checkbox reCAPTCHA</label>
                                          </div>
                                       </div>
                                    
                                 </div>
                              

                                 <div class="col-md-12 mt-3">
                                    <div class="form-group">
                                       <button class="btn btn-primary">Save</button>
                                    </div>
                                 </div>
                               </div>
                              </div>
                           </div>
                           <div class="tab-pane" id="tab_property_42">
                              <div class="row">
                                 <div class="col-md-6">
                                    <div class="row">
                                       <div class="col-md-12 nested-panel-heading skill-heading">
                                          <h3 class="nested-title">Buttons and Colors </h3>
                                       </div>
                                       
                                       <div class="clearfix"></div>
                                       <div class="col-md-12">  
                                          <p>
                                          Select the color theme for the customer chat form, The primary color is used for the header and buttons, and the secondary color is used for the chat with us button on your web page.
                                       </p>     
                                          <div class="theme-pallate">
                                             <div class="color-palette-box tv-theme-10">
                                                <input type="radio" checked class="mright-15" name="theme" value="theme10" v-model="theme"  v-on:click="selecttheme('theme10')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                             <div class="color-palette-box tv-theme-1">
                                                <input type="radio"  class="mright-15" name="theme" value="theme1" v-model="theme" v-on:click="selecttheme('theme1')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             
                                             </div>
                                             <div class="color-palette-box tv-theme-2">
                                                <input type="radio" class="mright-15" name="theme" value="theme2" v-model="theme"  v-on:click="selecttheme('theme2')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                                
                                             </div>
                                             <div class="color-palette-box tv-theme-3">
                                                <input type="radio" class="mright-15" name="theme" value="theme3" v-model="theme"  v-on:click="selecttheme('theme3')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                                
                                             </div>
                                             <div class="color-palette-box tv-theme-4">
                                                <input type="radio" class="mright-15" name="theme" value="theme4" v-model="theme"  v-on:click="selecttheme('theme4')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                             <div class="color-palette-box tv-theme-5">
                                                <input type="radio" class="mright-15" name="theme" value="theme5" v-model="theme"  v-on:click="selecttheme('theme5')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                             <div class="color-palette-box tv-theme-6">
                                                <input type="radio" class="mright-15" name="theme" value="theme6" v-model="theme"  v-on:click="selecttheme('theme6')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                             <div class="color-palette-box tv-theme-7">
                                                <input type="radio" class="mright-15" name="theme" value="theme7" v-model="theme"  v-on:click="selecttheme('theme7')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                             <div class="color-palette-box tv-theme-8">
                                                <input type="radio" class="mright-15" name="theme" value="theme8" v-model="theme"  v-on:click="selecttheme('theme8')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                             <div class="color-palette-box tv-theme-9">
                                                <input type="radio" class="mright-15" name="theme" value="theme9" v-model="theme"  v-on:click="selecttheme('theme9')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                             
                                             <div class="color-palette-box tv-theme-11">
                                                <input type="radio" class="mright-15" name="theme" value="theme11" v-model="theme"  v-on:click="selecttheme('theme11')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                             <div class="color-palette-box tv-theme-12">
                                                <input type="radio" class="mright-15" name="theme" value="theme12" v-model="theme"  v-on:click="selecttheme('theme12')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                             <div class="color-palette-box tv-theme-13">
                                                <input type="radio" class="mright-15" name="theme" value="theme13" v-model="theme"  v-on:click="selecttheme('theme13')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                             <div class="color-palette-box tv-theme-14">
                                                <input type="radio" class="mright-15" name="theme" value="theme14" v-model="theme"  v-on:click="selecttheme('theme14')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                             <div class="color-palette-box tv-theme-15">
                                                <input type="radio" class="mright-15" name="theme" value="theme15" v-model="theme"  v-on:click="selecttheme('theme15')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                             <div class="color-palette-box tv-theme-16">
                                                <input type="radio" class="mright-15" name="theme" value="theme16" v-model="theme"  v-on:click="selecttheme('theme16')">
                                                <div class="color-palette-set">
                                                   <div class="color-palette primary-color"></div>
                                                   <div class="color-palette secondary-color"></div>
                                                </div>
                                             </div>
                                          </div>                         
                                       </div>
                                    </div>
                                    <div class="row">
                                       <div class="col-md-12">
                                          <div class="nested-panel-heading skill-heading">
                                             <h3 class="nested-title">Override Theme Header Colors (optional)</h3>

                                             </div>
                                             <p>You can override the theme's header background and text color using the options below.</p>
                                          
                                          <div class="row">
                                             <lable class="control-lable col-md-6">
                                                Specify the new color for header background.
                                             </lable>
                                             <div class="col-12 col-sm-12 col-md-6 col-lg-6">                  
                                                   <div class="simple-label multiple pos-rel">
                                                      <div class="mbottom-15">
                                                         <div class="float-btn-group" >
                                                            <ColorPickerInstance palette="dark"></ColorPickerInstance>
                                                         </div>
                                                      </div>
                                                   </div>
                                             </div>
                                          </div>
                                          
                                          <div class="row">
                                             <lable class="control-lable col-md-6">
                                                Specify a new color for agent available text.
                                             </lable>
                                             <div class="col-12 col-sm-12 col-md-6 col-lg-6">                  
                                                   <div class="simple-label multiple pos-rel">
                                                   <div class="mbottom-15">
                                                      <div class="float-btn-group" >
                                                         <ColorPickerInstance palette="light"></ColorPickerInstance>
                                                      </div>
                                                      </div>
                                                   </div>
                                             </div>
                                          </div>
                                          <p>Note:- <span class="text-primary">You can override the header colors through the override code</span></p>
                                          </div>
                                    </div>
                                    <div class="row">
                                       <div class="col-md-12">
                                          <div class="nested-panel-heading skill-heading">
                                             <h3 class="nested-title">Header Logo (optional)</h3>
                                          </div>
                                          <p>The default customer chat form does not include a logo in the header of the form. Provide a URL to your web hosted logo to display in the header.</p>
                                          <div class="row">
                                             <div class="col-12 col-sm-12 col-md-12 col-lg-12">                  
                                                <input type="text" class="form-control" v-model="chatHeaderLogo" >  
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                                 <div class="col-md-6">
                                    <div class="row">
                                       <div class="col-md-12 nested-panel-heading skill-heading">
                                          <h3 class="nested-title">Chat Form Preview</h3>
                                       </div>
                                    </div>
                                    <div class="chat-preview-box position-relative" style="display:flex" v-bind:class="theme">
                                       <div class="chat-container">  
                                          <a href="" class="btn open-button pull-right chat-btn-rd"><i class="fa fa fa-comments-o"></i></a>
                                          <div class="chat-popup animated fadeInUp"> 
                                             <div class="form-container">
                                             <div class="chat-body-container">
                                                
                                                      <div class="body-container">
                                                         <div class="header">
                                                            <div class="chat-btn pull-right">
                                                               <button type="button" title="Leave Message" class="btn btn-sm">
                                                                  <span class="fa fa-envelope-o"></span>
                                                               </button>
                                                               <button type="button" title="Volume" class="btn btn-sm">
                                                                  <span class="fa fa-volume-up"></span>
                                                               </button>
                                                               <button type="button" title="Print" class="btn btn-sm">
                                                                  <span class="fa fa-print"></span>
                                                               </button>
                                                               <button type="button" title="Cancel Chat Request" class="btn btn-sm close-btn">
                                                                  <span class="fa fa-times"></span></button>
                                                               </div>
                                                            </div>
                                                            <div class="cust-chat-header" style="background: rgb(54, 127, 169); color: rgb(255, 255, 255);">
                                                               
                                                               <img v-if="chatHeaderLogo != ''" class="sitelogo" v-bind:src="chatHeaderLogo">
                                                               <i class="fa fa-circle online"></i> <!-- <span class="user-status">Agents are available</span>-->
                                                            </div>

                                                            <div class="m40">
                                                               <div class="col-md-12 col-sm-12">
                                                                  <p>Please select the topic/department to begin your chat.</p>
                                                                  <div class="form-group">
                                                                  <div class="form-group"><label for="topicID" class="control-label">Topic / Department <span class="required">*</span> <i class="fa fa-spinner fa-spin fa-fw" style="display: none;"></i></label><div class="has-error"><div tabindex="-1" class="multiselect"><!-- Search --><input type="text" class="multiselect-search"><!-- Tags (with search) --><!--v-if--><!-- Single label --><!--v-if--><!-- Multiple label --><!--v-if--><!-- Placeholder --><div class="multiselect-placeholder">Select or search for a topic</div><!-- Spinner --><!--v-if--><!-- Clear --><!--v-if--><!-- Caret --><span class="multiselect-caret"></span><!-- Options --><div class="multiselect-dropdown is-hidden" tabindex="-1"><ul class="multiselect-options"><li class="multiselect-group"><div class="multiselect-group-label"><span>St Louis</span></div><ul class="multiselect-group-options"><li class="multiselect-option"><!--v-if--><span class="disabled op-level-0" title="There are no agents available for this topic. You can select this topic to leave a message, or choose a topic with available agents to chat">Other</span></li><li class="multiselect-option"><!--v-if--><span class="disabled op-level-1" title="There are no agents available for this topic. You can select this topic to leave a message, or choose a topic with available agents to chat">_Spam</span></li><li class="multiselect-option"><!--v-if--><span class="disabled op-level-1" title="There are no agents available for this topic. You can select this topic to leave a message, or choose a topic with available agents to chat">_Undeliverable</span></li><li class="multiselect-option"><!--v-if--><span class="disabled op-level-1" title="There are no agents available for this topic. You can select this topic to leave a message, or choose a topic with available agents to chat">Builder questions</span></li><li class="multiselect-option"><!--v-if--><span class="disabled op-level-1" title="There are no agents available for this topic. You can select this topic to leave a message, or choose a topic with available agents to chat">Homeowner questions</span></li><li class="multiselect-option"><!--v-if--><span class="disabled op-level-1" title="There are no agents available for this topic. You can select this topic to leave a message, or choose a topic with available agents to chat">w_Request retrofit quote</span></li><li class="multiselect-option"><!--v-if--><span class="disabled op-level-2" title="There are no agents available for this topic. You can select this topic to leave a message, or choose a topic with available agents to chat">1. Scheduled Visits</span></li><li class="multiselect-option"><!--v-if--><span class="disabled op-level-2" title="There are no agents available for this topic. You can select this topic to leave a message, or choose a topic with available agents to chat">2. Open Quotes</span></li><li class="multiselect-option"><!--v-if--><span class="disabled op-level-2" title="There are no agents available for this topic. You can select this topic to leave a message, or choose a topic with available agents to chat">3. Unscheduled Installs</span></li><li class="multiselect-option"><!--v-if--><span class="disabled op-level-2" title="There are no agents available for this topic. You can select this topic to leave a message, or choose a topic with available agents to chat">4. Scheduled Installs</span></li><li class="multiselect-option"><!--v-if--><span class="disabled op-level-2" title="There are no agents available for this topic. You can select this topic to leave a message, or choose a topic with available agents to chat">5a. Completed - Accepted</span></li><li class="multiselect-option"><!--v-if--><span class="disabled op-level-2" title="There are no agents available for this topic. You can select this topic to leave a message, or choose a topic with available agents to chat">5b. Completed - Declined</span></li></ul></li></ul><!--v-if--><!--v-if--></div><!-- Hacky input element to show HTML5 required warning --><!--v-if--><!-- Native input support --><!--v-if--><!-- Create height for empty input --><div class="multiselect-spacer"></div></div><!--v-if--></div></div>
                                                                  </div>
                                                                  <div class="mtop-15"><button type="submit" class="btn btn-primary" style="background: rgb(54, 127, 169);">Next <i class="fa fa-spinner fa-spin fa-fw" style="display: none;"></i></button></div>
                                                               </div>
                                                            </div>
                                                         
                                                      </div>
                                                      <div class=""><div class="mb-3 pull-right">
                                                         <div class="poweredby-logo" style="text-align: center;"> 
                                                            Powered By: <a target="_blank" rel="noopener" href="http://www.iservice.us/"><b>iService <span class="register-trade-mark">®</span></b></a></div></div></div>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                    <!--<a :href="getImgUrl2(theme)" target="_blank">
                                       <img :src="getImgUrl2(theme)" class="w-auto h-auto">
                                    </a>-->
                                    
                                 </div>
                              </div>
                              <div class="row mt-3">
                                 <div class="col-md-12"><div class="form-group"><button class="btn btn-primary">Save</button></div></div>
                              </div>
                           </div>
                           <div class="tab-pane" id="tab_property_43">
                              <div class="row form-verticle">
                                 <p class="col-md-12 text-red">*Do not use this feature unless you are experienced with CSS and HTML.</p>
                                 <p class="col-md-12">
                                 You can override any of the code in your portal by using the panels below. Your changes will override any elements you select, including any theme settings.
                                 </p>
                                 <div class="form-group">
                                    <label class="col-md-12 control-label text-left">Head Elements <span v-tooltip="{text: 'You can add your own code to the HEAD section of the portals page. Be sure to surround your changes with the proper tags, such as <style>, <title>, etc.',theme: {placement: 'bottom', }}"><i class="fa fa-question-circle text-info help-icon"></i></span></label>
                                    <div class="col-md-9">
                                    <textarea type="text" class="form-control h-300p"></textarea>
                                    </div>
                                 </div>
                                 <div class="form-group">
                                    <label class="col-md-3 control-label text-left">Component Templates <span v-tooltip="{text: 'You can override the Vue.js code that comprises the customer portal. Click here to view the contents of the underlying source code for the customer portal. Your code entered in this section will update the Vue.js Components.',theme: {placement: 'bottom', }}"><i class="fa fa-question-circle text-info help-icon"></i></span> </label>
                                    <div class="col-md-9">
                                    <textarea type="text" class="form-control h-300p"></textarea>
                                    </div>
                                 </div>
                                 <div class="form-group">
                                    <label class="col-md-3 control-label text-left">Components Javascript <span v-tooltip="{text: 'You can insert your own JavaScript into the customer portal using the section below. Either enclose your JS within script tags or reference a CDN version of the JS.',theme: {placement: 'bottom', }}"><i class="fa fa-question-circle text-info help-icon"></i></span></label>
                                    <div class="col-md-9">
                                       <textarea type="text" class="form-control h-300p"></textarea>
                                    </div>
                                 </div>
                                 <div class="col-md-12">
                                    <div class="form-group">
                                       <button class="btn btn-primary">Save</button>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="tab-pane" id="tab_property_44">
                              <div class="search-panel">
                                    <p>Before a customer submits the chat form, they complete a pre-chat survey that must include their email address and short description of their issue. These are required fields for creating an interaction so the chat history can be saved for future reference. You can add other contact properties to the chat form to capture additional information.</p>
                                    <div class="panel panel-default col-12 bg-gray-light p-2">
                                       <div class="row">
                                          <div class="col-md-3"><label>Property List</label></div>
                                          <div class="col-md-3"><label>Field Name</label></div>
                                          <div class="col-md-3"><label>Input Requirement</label></div>
                                       </div>
                                       <div class="row mb-3">
                                          <div class="col-12 col-md-3">
                                             <Multiselect
                                                v-model="value"
                                                placeholder="-Select or search for property-"
                                                label="name"
                                                :groups="false"
                                                :searchable="true"
                                                :options="[  { value: 'Last Name', name: 'Last Name',level:'1'},{ value: 'First Name', name: 'First Name',level:'1'},
                                                      
                                                ]"
                                                >
                                                <template v-slot:option="{ option }">
                                                <span v-bind:class="'op-level-' + option.level"> {{ option.name }} </span>
                                                </template>
                                             </Multiselect>
                                          </div>
                                          <div class="col-12 col-md-3">
                                             <input class="form-control" type="text" value="Last Name">
                                          </div>
                                          <div class="col-12 col-md-3">
                                             <select class="form-control">
                                                <option>Optional</option>
                                                <option>Required</option>
                                             </select>
                                          </div>
                                          <div class="col-md-2 text-right">
                                             <button type="button" class="btn btn-link btn-lg btn-sort p-1" uib-tooltip="Up" tooltip-placement="bottom"><i class="fa fa-chevron-circle-up text-primary"></i></button>
                                             <button type="button" class="btn btn-link btn-lg btn-sort p-1" uib-tooltip="Down" tooltip-placement="bottom"><i class="fa fa-chevron-circle-down text-primary"></i></button>
                                             <button class="btn btn-link btn-lg btn-sort p-1" type="button" uib-tooltip="Delete Step" tooltip-placement="bottom">
                                                   <i class="fa fa-times-circle text-red"></i>
                                             </button>
                                          </div>
                                       </div>
                                       <div class="row mb-3">
                                          <div class="col-12 col-md-3">
                                             <Multiselect
                                                v-model="value"
                                                placeholder="-Select or search for property-"
                                                label="name"
                                                :groups="false"
                                                :searchable="true"
                                                :options="[ { value: 'First Name', name: 'First Name',level:'1'},
                                                         { value: 'Last Name', name: 'Last Name',level:'1'},
                                                ]"
                                                >
                                                <template v-slot:option="{ option }">
                                                <span v-bind:class="'op-level-' + option.level"> {{ option.name }} </span>
                                                </template>
                                             </Multiselect>
                                          </div>
                                          <div class="col-12 col-md-3"><input class="form-control" type="text" value="First Name"></div>
                                          <div class="col-12 col-md-3">
                                             <select class="form-control">
                                                <option>Optional</option>
                                                <option>Required</option>
                                             </select>
                                          </div>
                                          <div class="col-md-2 text-right">
                                             <button type="button" class="btn btn-link btn-lg btn-sort p-1" uib-tooltip="Up" tooltip-placement="bottom"><i class="fa fa-chevron-circle-up text-primary"></i></button>
                                             <button type="button" class="btn btn-link btn-lg btn-sort p-1" uib-tooltip="Down" tooltip-placement="bottom"><i class="fa fa-chevron-circle-down text-primary"></i></button>
                                             <button class="btn btn-link btn-lg btn-sort p-1" type="button" uib-tooltip="Delete Step" tooltip-placement="bottom">
                                                   <i class="fa fa-times-circle text-red"></i>
                                             </button>
                                          </div>
                                       </div>
                                       <div class="row mb-3">
                                          <div class="col-12 col-md-3">
                                             <select disabled class="form-control">
                                                <option>Login</option>
                                             </select>
                                          </div>
                                          <div class="col-12 col-md-3">
                                             <input class="form-control" type="text" value="Email Address">
                                          </div>
                                          <div class="col-12 col-md-3">
                                             <select disabled class="form-control">
                                                <option>Required</option>
                                             </select>
                                          </div>
                                          <div class="col-md-2 text-right">
                                             <button type="button" class="btn btn-link btn-lg btn-sort p-1" uib-tooltip="Up" tooltip-placement="bottom"><i class="fa fa-chevron-circle-up text-primary"></i></button>
                                             <button type="button" class="btn btn-link btn-lg btn-sort p-1" uib-tooltip="Down" tooltip-placement="bottom"><i class="fa fa-chevron-circle-down text-primary"></i></button>
                                             <button class="btn btn-link btn-lg btn-sort p-1" type="button" uib-tooltip="Delete Step" tooltip-placement="bottom">
                                                   <i class="fa fa-times-circle text-red"></i>
                                             </button>
                                          </div>
                                       </div>
                                       <div class="row mb-3">
                                          <div class="col-12 col-md-3">
                                             <select disabled class="form-control">
                                                <option>Subject</option>
                                             </select>
                                          </div>
                                          <div class="col-12 col-md-3">
                                             <input class="form-control" type="text" value="Enter a short description of your issue"></div>
                                          <div class="col-12 col-md-3">
                                             <select disabled class="form-control">
                                                <option>Required</option>
                                             </select>
                                          </div>
                                          <div class="col-md-2 text-right">
                                             <button type="button" class="btn btn-link btn-lg btn-sort p-1" uib-tooltip="Up" tooltip-placement="bottom"><i class="fa fa-chevron-circle-up text-primary"></i></button>
                                             <button type="button" class="btn btn-link btn-lg btn-sort p-1" uib-tooltip="Down" tooltip-placement="bottom"><i class="fa fa-chevron-circle-down text-primary"></i></button>
                                             <button class="btn btn-link btn-lg btn-sort p-1" type="button" uib-tooltip="Delete Step" tooltip-placement="bottom">
                                                   <i class="fa fa-times-circle text-red"></i>
                                             </button>
                                          </div>
                                       </div>
                                       <div class="row float-end"><button class="btn btn-lg btn-link" type="button"><i class="fa fa-plus-circle text-light-blue"></i> Add another property </button></div>
                                    </div>
                              </div>
                              <div class="row">
                                 <div class="col-md-12">
                                    <div class="form-group">
                                       <button class="btn btn-primary">Save</button>
                                    </div>
                                 </div>
                              </div>
                           </div>
                         
                        </div> 
                     </div>
          
      </div>
   </div>

</template>

<script>
import DetailsandattachmentsTabContent from '../components/DetailsandattachmentsTabContent.vue';
import InteractionPropertyTab from '../components/InteractionPropertyTab.vue';
import CustomerPortalList from '../components/CustomerPortalList.vue';
import DashbordConfig from '../components/DashbordConfig.vue';
import Toggle from '@vueform/toggle'
import Multiselect from '@vueform/multiselect'
import { ColorPicker } from "vue-accessible-color-picker";

import CodeHighlight from "vue-code-highlight/src/CodeHighlight.vue";
import "vue-code-highlight/themes/duotone-sea.css";
import "vue-code-highlight/themes/window.css";
import { HighCode } from 'vue-highlight-code';
import 'vue-highlight-code/dist/style.css';
import ColorPickerInstance from '../components/ColorPickerInstance2.vue';

import slider from "vue3-slider"
import Slider2 from '@vueform/slider'
export default {
  name: 'Customer Portal Tabs',
   components: {
      DetailsandattachmentsTabContent,
      InteractionPropertyTab,
      Multiselect,
      CustomerPortalList,
      ColorPicker,
      DashbordConfig,
      Toggle,
      CodeHighlight,
      HighCode,
      ColorPickerInstance,
      "vue3-slider": slider,
      Slider2
  },
  mounted(){
          
      },
   data() {
    return {
       color: 'black',
       color1: 'black',
       colpicker1 :false,
       colpicker2 : false ,
       color3: 'black',
       color4: 'black',
       colpicker3 :false,
       colpicker4 : false ,
       showDetails :false,
       showAlert:false,
       createNew:false,
       theme:'theme10',
       wordpressSettings:false,
       independentSettings:false,
       websiteSettings:false,
       wholetopiclist:false,
       singletopic:true,
       multipletopic:false,
       enableCaptcha:true,
       chatHeaderLogo:'https://iservice.us/wp-content/uploads/2020/04/iservice-logo-white.png',
       livechatsetting:true,
       chatBotSetting:false,
       optionparameter : [1],
       value: 20,
       value2: 0.01,
       value3: 0.01,
       value4: 1,
       tools:false
     }
  },

  methods: {
   addValue() {
      this.optionparameter.push('')
      this.searchlength = parseInt(this.searchlength) + 1;
   },
   removeValue(index) {
      if(this.optionparameter.length > 1){
       this.optionparameter.splice(index, 1);
       this.searchlength = parseInt(this.searchlength) - 1;
      }
    },
    updateColor (eventData) {
      this.color = eventData.cssColor
    },
    updateColor1 (eventData) {
      this.color1 = eventData.cssColor
    },
    updateColor3 (eventData) {
      this.color3 = eventData.cssColor
    },
    updateColor4 (eventData) {
      this.color4 = eventData.cssColor
    },
    getImgUrl2(theme) {
       return require('../assets/theme/chat/'+theme+'.png')
    }
  },
  mounted() { 
    this.emitter.on("show-message-details", Data => {
      this.showDetails = Data.showDetails;
      this.createNew = false;
    });
  }

}

</script>

